import { FeedbackContent, Feedback, View } from './types'

export const getFeedbackContent = (
  email: string,
  state: Feedback = 'tokenExpired',
): FeedbackContent => {
  const configs = {
    success: {
      title: 'Senha criada com sucesso',
      description:
        'O acesso ao aplicativo já está liberado. Basta abrir o aplicativo e entrar com suas credenciais e a senha recém-criada.',
    },
    tokenExpired: {
      title: 'Este link não é mais válido',
      description:
        'O prazo de uso expirou. Peça um novo link para seguir com o processo de redefinição de senha.',
      action: 'Enviar novo link',
    },
    emailSent: {
      title: 'Um novo e-mail foi enviado',
      description: `Um novo e-mail com um link válido foi enviado para ${email}. Caso não o encontre, verifique a pasta de spam ou tente novamente em alguns minutos.`,
    },
    emailError: {
      title: 'Falha no envio',
      description: `Não foi possível enviar o e-mail de recuperação para ${email}. Por favor, tente novamente em alguns instantes.`,
      action: 'Enviar novamente',
    },
  }

  return configs[state]
}

export const getView = (
  isValidatingToken: boolean,
  hasFeedback: boolean,
): View => {
  if (isValidatingToken) return 'loading'
  if (hasFeedback) return 'feedback'
  return 'form'
}
